import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    CircularProgress,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { createAPIEndpoint3, ENDPIONTS } from '../../api';

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2)
    },
    header: {
        marginBottom: theme.spacing(2)
    },
    ok: {
        fontWeight: 'bold'
    },
    pending: {
        fontWeight: 'bold'
    }
}));

export default function ReglasColegiaturaDetalle() {
    const classes = useStyles();
    const { id, ciclo } = useParams();
    const [loading, setLoading] = useState(true);
    const [resultado, setResultado] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        setLoading(true);
        createAPIEndpoint3(ENDPIONTS.REGLAS_COLEGIATURA_DETALLE)
            .fetchAllPriceByStudent(id, ciclo)
            .then(res => {
                setResultado(res.data);
                setLoading(false);
            })
            .catch(() => {
                setError('No fue posible consultar el detalle de reglas del alumno.');
                setLoading(false);
            });
    }, [id, ciclo]);

    if (loading) {
        return (
            <Grid container justify="center" className={classes.root}>
                <CircularProgress />
            </Grid>
        );
    }

    if (error) {
        return <Typography className={classes.root}>{error}</Typography>;
    }

    const detalles = resultado && resultado.detalles ? resultado.detalles : [];

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <Typography variant="h5">Validación de requisitos para pago de colegiatura</Typography>
                <Typography variant="body1">{resultado ? resultado.mensaje : ''}</Typography>
                <Typography variant="body2">
                    Motor: {resultado && resultado.estadoMotor ? resultado.estadoMotor : 'SIN INFORMACIÓN'}
                    {' | '}Inicio parametrizado: {resultado && resultado.fechaInicioEjecucion
                        ? new Date(resultado.fechaInicioEjecucion).toLocaleDateString()
                        : '-'}
                </Typography>
                <Typography variant="body2">
                    Reglas: {resultado ? resultado.totalReglas : 0}
                    {' | '}Periodos: {resultado ? resultado.totalPeriodos : 0}
                    {' | '}Pagados: {resultado ? resultado.totalPagados : 0}
                    {' | '}No uso: {resultado ? resultado.totalNoUso : 0}
                    {' | '}Pendientes: {resultado ? resultado.totalPendientes : 0}
                </Typography>
                <Typography variant="caption">
                    “No uso” significa que el servicio fue registrado expresamente como no utilizado durante ese mes. Una baja de servicio conserva la revisión de los periodos anteriores a la fecha efectiva de baja.
                </Typography>
            </div>

            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Concepto</TableCell>
                            <TableCell>Regla</TableCell>
                            <TableCell>Nivel</TableCell>
                            <TableCell>Periodicidad</TableCell>
                            <TableCell>Modalidad</TableCell>
                            <TableCell>Periodo</TableCell>
                            <TableCell>Estatus</TableCell>
                            <TableCell>Evidencia</TableCell>
                            <TableCell>Fecha</TableCell>
                            <TableCell>Monto</TableCell>
                            <TableCell>Motivo / observación</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {detalles.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={11}>El alumno no tiene reglas configuradas para este ciclo escolar.</TableCell>
                            </TableRow>
                        )}

                        {detalles.map((item, index) => {
                            const fecha = item.fechaPago || item.fechaEvidencia;
                            const motivo = item.motivoEvidencia
                                ? `${item.motivoEvidencia}. ${item.observacion || ''}`
                                : item.observacion;

                            return (
                                <TableRow key={`${item.idreglacolegiaturaalumno}-${item.clavePeriodo}-${index}`}>
                                    <TableCell>{item.concepto}</TableCell>
                                    <TableCell>{item.tipoRegla}</TableCell>
                                    <TableCell>{item.nivel || '-'}</TableCell>
                                    <TableCell>{item.periodicidad || '-'}</TableCell>
                                    <TableCell>{item.modalidad || '-'}</TableCell>
                                    <TableCell>{item.periodo}</TableCell>
                                    <TableCell className={item.cumple ? classes.ok : classes.pending}>{item.estatus}</TableCell>
                                    <TableCell>{item.tipoEvidencia || '-'}</TableCell>
                                    <TableCell>{fecha ? new Date(fecha).toLocaleString() : '-'}</TableCell>
                                    <TableCell>{item.montoPagado != null ? `$${Number(item.montoPagado).toFixed(2)}` : '-'}</TableCell>
                                    <TableCell>{motivo || '-'}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}
